import { Injectable, Injector } from '@angular/core';
import { CustomProduct } from '@product/const';
import { ProductListAnalyticsService } from './product-list-analytics.service';

@Injectable({ providedIn: 'root' })
export class WishListAnalyticsService extends ProductListAnalyticsService {
  constructor(injector: Injector) {
    super(injector);
  }

  onViewProductList(products: CustomProduct[], pageNumber?: number): void {
    const listName = `Wishlist_${pageNumber || 1}`;
    this.analyticsListName$.next(listName);

    super.onViewProductList(products);
  }
}
